/**
 * Scroll animation utilities for the grid widget
 */

// helper: find element's offsetTop relative to a scrollable ancestor
export function offsetTopRelative(node, ancestor) {
  let y = 0;
  let n = node;
  while (n && n !== ancestor && n instanceof HTMLElement) {
    y += n.offsetTop;
    n = n.offsetParent;
  }
  return y;
}

// rAF scroller (always used; avoids browser "blink")
export function animateScroll(container, to, duration = 380) {
  const start = container.scrollTop;
  const change = to - start;
  if (Math.abs(change) < 1) return; // already there

  const t0 = performance.now();
  const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

  function step(now) {
    const p = Math.min(1, (now - t0) / duration);
    container.scrollTop = start + change * ease(p);
    if (p < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}
